import "../../loader.css";

const DashboardLoader = () => {
  return <div className="loader"></div>;
};

export default DashboardLoader;
